import { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { useRouter } from "expo-router";

import { AccountForm } from "~/components/AccountForm";
import { useHonoClient } from "~/hooks/HonoContext";
import { supabaseClient, useSessionContext } from "~/lib/supabase";

export default function Invite() {
  const { replace } = useRouter();
  const { hc } = useHonoClient();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<"ok" | "already-accepted" | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const { session } = useSessionContext();

  const inviteCode = new URL(window.location.href).searchParams.get(
    "invite_code",
  );

  // validate token
  useEffect(() => {
    async function validateToken() {
      if (!inviteCode) {
        setError("Invite code missing");
        return;
      }
      setIsLoading(true);
      setError(null);
      try {
        const response = await hc.auth["validate-token"].$post({
          json: {
            token: inviteCode,
          },
        });
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("Invite not found");
          } else {
            throw new Error("Failed to validate token");
          }
        }
        const result = await response.json();
        if (result.status === "ok") {
          setStatus("ok");
          setEmail(result.email);
        } else if (result.status === "already-accepted") {
          setStatus("already-accepted");
        }
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        } else {
          console.error(error);
          setError("Something went wrong");
        }
      } finally {
        setIsLoading(false);
      }
    }
    validateToken();
  }, [inviteCode]);

  async function onAccountFormSubmit(data: {
    password: string;
    displayName: string;
    slug: string;
  }) {
    if (!inviteCode) return;
    const { password, displayName, slug } = data;
    const response = await hc.auth["signup-with-token"].$post({
      json: {
        token: inviteCode,
        password,
        displayName,
        slug,
      },
    });
    if (response.ok) {
      const result = await response.json();
      const { email, otp, orgSlug } = result;
      const authResponse = await supabaseClient.auth.verifyOtp({
        email,
        token: otp,
        type: "email",
      });
      if (authResponse.data.user) {
        replace(
          `/create-account/profile?next=${encodeURIComponent(`/${orgSlug}`)}`,
        );
      } else {
        setError(authResponse.error?.message ?? "Unknown error");
      }
    } else {
      setError("Failed to sign up");
    }
  }

  // useEffect(() => {
  //   async function signup() {
  //     if (!inviteCode) return;
  //     setIsLoading(true);
  //     setError(null);
  //     try {
  //       const response = await hc.auth["signup-with-token"].$post({
  //         json: {
  //           token: inviteCode,
  //         },
  //       });
  //       if (!response.ok) {
  //         switch (response.status) {
  //           case 404:
  //             throw new Error("Invite not found");
  //           case 400:
  //             throw new Error("Invite already accepted");
  //           default:
  //             throw new Error("Failed to sign up");
  //         }
  //       }
  //       const result = await response.json();
  //       const { email, otp } = result;
  //       const authResponse = await supabaseClient.auth.verifyOtp({
  //         email,
  //         token: otp,
  //         type: "email",
  //       });
  //       console.log(authResponse);
  //       if (authResponse.data.user) {
  //         replace(`/create-account?email=${encodeURIComponent(email)}`);
  //       } else {
  //         setError(authResponse.error?.message ?? "Unknown error");
  //       }
  //     } catch (error) {
  //       if (error instanceof Error) {
  //         setError(error.message);
  //       }
  //       console.error(error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  //   signup();
  // }, [inviteCode]);
  if (isLoading) {
    return (
      <View className="container">
        <Text className="text-text-primary">Validating invite...</Text>
      </View>
    );
  }

  return (
    <View className="container">
      <AccountForm email={email || ""} onSubmit={onAccountFormSubmit} />
      {error && <Text className="text-red-500">{error}</Text>}
    </View>
  );
}
